module.exports = "<div class=\"checkout-thank-you\"> <checkout-user-info user=\"$ctrl.user\" purchase-complete=\"true\" show-container=\"true\"></checkout-user-info> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/checkout/components/thankYou/thankYou.html
// module id = 1316
// module chunks = 28